import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-weight-slider',
  templateUrl: './weight-slider.component.html',
  standalone: false
})
export class WeightSliderComponent implements OnInit {
  @Input() form!: FormGroup;
  @Input() prefix: string = 'weight_';
  @Input() labels: Record<string, string> = {};
  @Input() totalWeights!: number;

  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {
    Object.keys(this.form.controls)
      .filter(k => k.startsWith(this.prefix))
      .forEach(key => {
        this.form.get(key)?.valueChanges.subscribe(() => {
          this.cd.detectChanges(); // fuerza actualización de la vista
        });
      });
  }
    
    get isTotalCorrect(): boolean {
        return this.totalWeights === 100;
    }
}
